import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import downloadIcon from "../assets/icons/download.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import controlpanel from "../assets/image/uninstallationGopaperlessAgent/controlpanel.png";
import finish from "../assets/image/uninstallationGopaperlessAgent/finish.png";
import listinstall from "../assets/image/uninstallationGopaperlessAgent/listinstall.png";
import programs from "../assets/image/uninstallationGopaperlessAgent/programs.png";
import programsandfeatures from "../assets/image/uninstallationGopaperlessAgent/programsandfeatures.png";
import uninstall from "../assets/image/uninstallationGopaperlessAgent/uninstall.png";
import uninstallchange from "../assets/image/uninstallationGopaperlessAgent/uninstallchange.png";
import welcome from "../assets/image/uninstallationGopaperlessAgent/welcome.png";

const UnInstallGopaperlessAgent = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-03";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return `
${t("sidebar.install.itemUninstall")}

${t("uninstallationGopaperlessAgent.step1").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step2").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step3").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step4").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step5").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step6").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step7").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step8").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step9").replace(/<[^>]+>/g, "")}

${t("uninstallationGopaperlessAgent.step10").replace(/<[^>]+>/g, "")}
    `.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={downloadIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.install.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.install.itemUninstall")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: controlpanel

                        }}>
                            <img
                                src={controlpanel}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: programs

                        }}>
                            <img
                                src={programs}
                                alt="programs"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: programsandfeatures

                        }}>
                            <img
                                src={programsandfeatures}
                                alt="programsandfeatures"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: listinstall

                        }}>
                            <img
                                src={listinstall}
                                alt="listinstall"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: uninstallchange

                        }}>
                            <img
                                src={uninstallchange}
                                alt="uninstallchange"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step6"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step7"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: welcome

                        }}>
                            <img
                                src={welcome}
                                alt="welcome"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step8"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: uninstall

                        }}>
                            <img
                                src={uninstall}
                                alt="uninstall"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step9"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="uninstallationGopaperlessAgent.step10"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: finish

                        }}>
                            <img
                                src={finish}
                                alt="finish"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col tabletpro:flex-row desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.install.itemInstall")}
                            to="/install-gopaperlessagent"
                        />
                        <NextSectionCard
                            label={t("sidebar.install.itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS")}
                            to="/guide-to-adding-and-trusting-digital-certificates-from-cas-on-macos"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default UnInstallGopaperlessAgent
